module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-404"
  }, [_c('div', {
    staticClass: "p-404__container js-page-container u-relative u-flex u-flex-ai--center u-flex-jc--center u-fit-w u-bg--white-near",
    style: ({
      'height': _vm.containerHeight + 'px',
      'margin-top': _vm.containerHeight > 0 ? _vm._headerRect.height + 'px' : 0
    })
  }, [_c('div', {
    staticClass: "p-404__container__wrapper u-flex u-flex-fd--column u-flex-ai--center u-w4of10 u-w8of10@md u-align-center"
  }, [_c('h1', [_c('span', {
    staticClass: "t-text--xs t-ffamily--domaine t-fweight--bold u-color--brand-gold u-uppercase",
    domProps: {
      "innerHTML": _vm._s(_vm.content.subtitle)
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "u-marg-t-xs"
  }, [_c('span', {
    staticClass: "t-text--lg t-ffamily--domaine t-fweight--light",
    domProps: {
      "innerHTML": _vm._s(_vm.content.page_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-xl u-marg-t-md@xxs"
  }, [_c('router-link', {
    staticClass: "p-404__container__wrapper__link u-relative u-inline-block u-fit u-click-area-xxs t-link",
    attrs: {
      "to": _vm.$root.getPageURLFromName(_vm.content.page.post_name)
    }
  }, [_c('span', {
    staticClass: "u-color--brand-gold u-uppercase t-ffamily--domaine t-fweight--light t-text--xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.link)
    }
  })])], 1)])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2ed44a8"}!./src/scripts/components/page-404/template.html
// module id = 202
// module chunks = 0